<div class="configure-fiber-wrapper">

  <div class="dialog-header">
    <div class="header-title-wrapper px-8 mb-8 justify-between">
      <div class="flex">
        <i class="fal fa-chevron-left text-white text-2xl cursor-pointer mr-4" (click)="close()"></i>
        <p class="title text-white text-2xl" *ngIf="ip">Configurar fibra óptica - <span class="text-accent">{{ip}}</span> <span><i *ngIf="pendingInQueue>0"
              class="fal fa-circle-exclamation"
              [matTooltip]="'Esta ip tiene '+ pendingInQueue +' configuraciones pendientes'"></i></span>
        </p>

        <p class="title text-white text-2xl" *ngIf="!ip">Router sin IP asignada</p>
      </div>
      <div class="flex gap-3 items-center">
        <div class="dialog-footer" [ngClass]="loadingApi==true ||  !checkRuleValid() ? 'disabled' : ''" *ngIf="ip">
          <div class="apply-many-button cursor-pointer " (click)="openAddToMore()">
            <span class="text-accent text-xl"><u >Aplicar a varias IP</u></span>
          </div>
         
        </div>
        <app-accent-button text="Guardar cambios" [selected]="true" (click)="finish()"></app-accent-button>
      </div>
    </div>
    <div class="header-buttons-tabs px-8 mb-8" *ngIf="ip">
      <app-accent-button text="Reglas" [selected]="true"></app-accent-button>
      <!-- <app-accent-button text="Limitación de datos" [selected]="false"></app-accent-button> -->
    </div>
  </div>

  <div *ngIf="!ip" class="no-ip-on-router">
    <p>Para utilizar el portal de restricciones, es necesario conectar el router</p>
  </div>

  <div style="flex: 1 1 auto; overflow-y: auto;" *ngIf="ip">
    <app-rules-editor mode="fiber" [ip]="ip" (deleteRuleEvent)="deleteRule($event)"></app-rules-editor>
  </div>
  
</div>